import React from 'react';

function Footer() {
  return (
    <footer className="bg-[#0F2C5E] text-white px-4 py-2">
      <div className="max-w-6xl w-full mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 text-sm">
        <div>
          <h3 className="font-bold mb-1">2290PAY.ORG</h3>
        </div>
        <div>
          <h3 className="font-bold mb-1">Contact US</h3>
          <ul>
            <li>support@2290pay.org</li>
          </ul>
        </div>
        <div>
          <h3 className="font-bold mb-1">Our Services</h3>
          <ul>
            <li>BOC3PAY.ORG</li>
            <li>UCRPAY.ORG</li>
          </ul>
        </div>
        <div>
          <h3 className="font-bold mb-1">Fast Links</h3>
          <ul>
            <li>2290 VIN Correction</li>
            <li>Form 2290 Online</li>
            <li>Efile 2290 Tax Online</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
